var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "What We Do",
      "tabActive": "Quality Control",
      "bg": "/images/sub/visual/sv4.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('div', {
    staticClass: "page-tit-wrap"
  }, [_c('h2', {
    staticClass: "page-tit"
  }, [_vm._v(" Quality Control ")]), _c('p', [_vm._v(" Systematic and efficient quality management system operation "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" of the entire process according to the quality management system procedure "), _c('br'), _vm._v(" Securing stable quality through trend analysis through the SPC system ")])])])], 1), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Quality Control System"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto d-none d-md-block",
    attrs: {
      "src": "/images/sub/wwd/control/control-img-en.png",
      "max-width": "940"
    }
  }), _c('v-img', {
    staticClass: "mx-auto d-block d-md-none",
    attrs: {
      "src": "/images/sub/wwd/control/control-img-mo-en.png",
      "max-width": "670"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }